export const MAX_FILE_SIZE_MB = 25;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
export const ACCEPTED_FILE_EXTENSIONS = [".ppt", ".pptx", ".pdf"];
export const ACCEPTED_FILE_EXTENSIONS_LABEL =
  ACCEPTED_FILE_EXTENSIONS.join(", ");
export const ACCEPTED_MIME_TYPES = new Set([
  "application/pdf",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
]);

export const VALIDATION_ERROR_AUTO_HIDE_DELAY_MS = 3 * 1000; // 3 seconds
